module Meevo.Plugins.EmmaAccountSettings {
    export class EmailMarketingSubmitModalController {
        static $inject = [
            "$mdDialog",
            "meevo.components.common.DataService",
            "meevo.AppSettings",
            "meevo.components.common.IdentityService",
            "meevo.components.busy.BusyService",
            "meevo.components.common.SecurityService",
            "meevo.components.modal.ModalService",
            "options",
            "$timeout",
            "$translate",
            "meevoDateFilterFilter",
            "$mdBottomSheet",
            "$rootElement"
        ];

        public model: Model.IEmmaSMSAccountSettings;

        public isSubmitting = false;

        public legalEntityTypeList = [
            { label: 'Private Company', value: 'LEGAL_ENTITY_TYPE_PRIVATE_COMPANY' },
            { label: 'Public Company', value: 'LEGAL_ENTITY_TYPE_PUBLIC_COMPANY' },
            { label: 'Non-Profit', value: 'LEGAL_ENTITY_TYPE_NON_PROFIT' },
            { label: 'Government', value: 'LEGAL_ENTITY_TYPE_GOVERNMENT' },
            { label: 'Sole Proprietor', value: 'LEGAL_ENTITY_TYPE_SOLE_PROPRIETOR' }
        ];

        constructor(
            private $mdDialog: angular.material.IDialogService,
            public dataService: Meevo.Components.BaseClasses.IDataService,
            private appSettings: Meevo.Components.Common.IAppSettings,
            public identityService: Meevo.Components.Common.IIdentityService,
            protected busyService: Meevo.Components.Busy.IBusyService,
            private securityService: Meevo.Components.Common.ISecurityService,
            public modalService: Meevo.Components.Modal.IModalService,
            public options: Meevo.Model.NotificationSetting,
            public $timeout: angular.ITimeoutService,
            public $translate: ng.translate.ITranslateService,
            public meevoDateFilter: any,
            public $mdBottomSheet: angular.material.IBottomSheetService,
            public $rootElement: angular.IRootElementService) {
            this.loadData();
        }

        loadData() {
            this.dataService.customMethodData(`${this.appSettings.API_ROOT}/SMSMarketing/RegistrationInfo`, "GET", null)
                .then(result => {
                    if (result && result.data) {
                        this.model = result.data;
                        this.model.storeName = result.data.name || null;
                        this.model.tenantId = this.identityService.current().tenantId || null;

                        if (result.data.address.countryCode === "1") {
                            this.model.businessRegistrationType = "BUSINESS_REGISTRATION_TYPE_EIN";
                        }
                    }
                });

            
        }

        save() {
            if (this.isSubmitting) return;

            if (Model.Guard.isNothing(this.model.storeName)
                || Model.Guard.isNothing(this.model.contactFirstName)
                || Model.Guard.isNothing(this.model.contactLastName)
                || Model.Guard.isNothing(this.model.address.address1)
                || Model.Guard.isNothing(this.model.address.city)
                || Model.Guard.isNothing(this.model.address.state)
                || Model.Guard.isNothing(this.model.address.zipCode)
                || Model.Guard.isNothing(this.model.address.country)
                || Model.Guard.isNothing(this.model.emailAddress)
                || Model.Guard.isNothing(this.model.webAddressUrl)
                || Model.Guard.isNothing(this.model.phoneNumber)
                || Model.Guard.isNothing(this.model.countryCode)
                || Model.Guard.isNothing(this.model.taxId)
                || Model.Guard.isNothing(this.model.legalEntityType)) {
                this.modalService.alert("MESSAGE_VERIFICATION_MISSING_INFO", Components.Modal.ModalTranslationModes.Translate, true);
                return;
            }

            // Validate taxId: must be 9 characters or in format XX-XXXXXXX
            if (this.model.taxId) {
                const nineCharRegex = /^.{9}$/;
                const einFormatRegex = /^\d{2}-\d{7}$/;
                if (!nineCharRegex.test(this.model.taxId) && !einFormatRegex.test(this.model.taxId)) {
                    this.modalService.alert("MESSAGE_TAXID_WRONG_FORMAT", Components.Modal.ModalTranslationModes.Translate, true);
                    return;
                }
            }

            // Validate webAddressUrl format
            try {
                const parsed = new URL(this.model.webAddressUrl);
                if (parsed.protocol !== "http:" && parsed.protocol !== "https:") {
                    this.modalService.alert("MESSAGE_WEBSITE_URL_INVALID", Components.Modal.ModalTranslationModes.Translate, true);
                    return;
                }

                // Ensure hostname contains a TLD (like .com or .net): must have a dot followed by 2+ alpha characters
                const hasTld = /\.[a-zA-Z]{2,}$/.test(parsed.hostname);
                if (!hasTld) {
                    this.modalService.alert("MESSAGE_WEBSITE_URL_INVALID", Components.Modal.ModalTranslationModes.Translate, true);
                    return;
                }
            } catch (error) {
                this.modalService.alert("MESSAGE_WEBSITE_URL_INVALID", Components.Modal.ModalTranslationModes.Translate, true);
                return;
            }

            return this.modalService
                .confirm("MESSAGE_SUBMIT_VERIFICATION", Components.Modal.ModalTranslationModes.Translate, true)
                .then(result => {
                    if (result) {
                        return this.postData();
                    }
                });

        }

        postData() {
            if (this.isSubmitting) return;
            this.isSubmitting = true;
            this.busyService.start();

            return this.dataService
                .customMethodData(`${this.appSettings.API_ROOT}/SMSMarketing/RegistrationInfo/Submit`, "POST", this.model)
                .then(response => {
                    if (response && response.data && response.data.isTFNVerificationSubmitted === true) {
                        return this.$mdDialog.hide(response);
                    }

                    this.isSubmitting = false;
                    this.modalService.alert("MESSAGE_SUBMIT_VERIFICATION_FAILED", Components.Modal.ModalTranslationModes.Translate, true);
                })
                .catch(() => {
                    this.isSubmitting = false;
                })
                .finally(() => { this.busyService.stop(); });
        }

        closeModal(e): void {
            if (e) e.stopPropagation();
            if (this.isSubmitting) return;
            this.$mdDialog.hide();
        }

    }

    angular.module("meevo.plugins.emmaAccountSettings")
        .controller("meevo.plugins.emmaAccountSettings.EmailMarketingSubmitModalController", EmailMarketingSubmitModalController);
}